import React from 'react';
import styles from './styles.module.css';

const Notification = ({ coin, coinType, date, time }) => {
    return (
        <div className={styles.notification}>
            <h3>Deposite Sucessful</h3>
            <p>You have deposited {coin} {coinType} at {date} {time} (UTC)</p>
        </div>
    )
}

export default Notification;